















import Vue from "vue";
import { gameStore } from "../store/game/store";
export default Vue.extend({
  computed: {
    visible() {
      return gameStore.state.ui.showNeedGlassDlg;
    }
  },
  methods: {
    dismiss() {
      gameStore.commitToggleNeedGlassDlg(false);
    }
  }
});
